(() => {
  const headerSelector = '.hdt-header-inline, .hdt-header-menu-bottom';
  const menuSelector = '#hdt-nav-ul';
  const overlaySelector = '.mantys-submenu-overlay';
  const instances = new WeakMap();

  const getOpenSubmenu = (menu) => {
    const openDetails = menu.querySelectorAll(
      ':scope > .hdt-menu-item > hdt-header-menu > details[open]'
    );

    for (const details of openDetails) {
      const summary = details.querySelector(':scope > summary');
      if (summary?.getAttribute('aria-expanded') === 'false') continue;

      const submenu = Array.from(details.children).find((element) =>
        element.classList.contains('hdt-sub-menu')
      );

      if (submenu) return submenu;
    }

    return null;
  };

  const setupOverlay = (header) => {
    if (!header || instances.has(header)) return;

    const menu = header.querySelector(menuSelector);
    const overlay = header.querySelector(overlaySelector);
    if (!menu || !overlay) return;

    let animationFrame;

    const update = () => {
      animationFrame = undefined;
      const submenu = getOpenSubmenu(menu);

      if (!submenu) {
        overlay.classList.remove('is-visible');
        return;
      }

      const submenuRect = submenu.getBoundingClientRect();
      const submenuHeight = Math.ceil(submenuRect.height);
      const availableHeight = Math.max(0, Math.ceil(window.innerHeight - submenuRect.top));
      const overlayHeight = Math.min(submenuHeight + 64, availableHeight);

      overlay.style.setProperty('--mantys-submenu-overlay-height', `${overlayHeight}px`);
      overlay.classList.toggle('is-visible', overlayHeight > 0);
    };

    const scheduleUpdate = () => {
      if (animationFrame) cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(update);
    };

    const handleViewportChange = () => {
      if (menu.querySelector('details[open]')) scheduleUpdate();
    };

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(menu, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['open', 'aria-expanded']
    });

    window.addEventListener('resize', handleViewportChange, { passive: true });
    window.addEventListener('scroll', handleViewportChange, { passive: true });
    instances.set(header, () => {
      observer.disconnect();
      window.removeEventListener('resize', handleViewportChange);
      window.removeEventListener('scroll', handleViewportChange);
      if (animationFrame) cancelAnimationFrame(animationFrame);
    });

    scheduleUpdate();
  };

  const initialize = (root = document) => {
    if (root.matches?.(headerSelector)) setupOverlay(root);
    root.querySelectorAll?.(headerSelector).forEach(setupOverlay);
  };

  initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const header = event.target.matches?.(headerSelector)
      ? event.target
      : event.target.querySelector?.(headerSelector);

    instances.get(header)?.();
    instances.delete(header);
  });
})();
